import {Component} from '@angular/core';
import {LoadingService} from '../services/loading.service';

@Component({
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  constructor(private loadingService: LoadingService) {
    this.loadingService.hide();
  }
}
